module.exports = __webpack_public_path__ + "media/images/index/board-26aab238971f34c430636e8f91800f43.svg";